<div [ngClass]="{ loading: pending }" appPadding="0">
  <div
    id="no-radius"
    fxLayout="row"
    appMargin
    class="ui basic segment"
    marginB="0px"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
  >
    <div fxFlex>YEAR</div>
    <div fxFlex>TOTAL PROFIT</div>
    <div fxFlex>ACCESSIBLE PROFIT</div>
    <div fxFlex>TURNOVER</div>
    <div fxFlex>TAX PAID</div>
  </div>
  <div
    appMargin="0"
    style="border-radius: 0px; box-shadow: none; border: none"
    class="ui segment data"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="15px"
    *ngFor="let unit of units"
  >
    <!-- <div fxFlex="5%">
      <sui-checkbox
        (checkChange)="onChange($event, unit)"
        [(ngModel)]="unit.selected"
      ></sui-checkbox>
    </div> -->
    <div fxFlex>{{ unit?.year }}</div>
    <div fxFlex>{{ unit?.totalProfit | currency: "NGN":"symbol-narrow" }}</div>
    <div fxFlex>
      {{ unit?.assessableProfit | currency: "NGN":"symbol-narrow" }}
    </div>
    <div fxFlex>{{ unit?.turnOver | currency: "NGN":"symbol-narrow" }}</div>
    <div fxFlex>{{ unit?.taxPaid | currency: "NGN":"symbol-narrow" }}</div>
  </div>
</div>
